import StoreApi from '../api/StoreApi';
import {localStore} from 'mutants-util';
import {storeKey} from '../const/app'
import tools from '../util/tools';

const emptyStore = {
    orgId : '',
    storeID: '',
    posCode: '',
    key: ''
}
export default class Store {

    constructor(storeInfos){
      if(storeInfos){
        this.posInfo = new Map();
        this.storeInfos = storeInfos.map(item => {
            const {PosInfo,...StoreInfo} = item;
            this.posInfo.set(`store_${StoreInfo.ID}`,PosInfo);
            return StoreInfo;
        });
      }

    }

    static async getStoreInfo(){
      const storeInfos = await StoreApi.getStoreInfos();
      let store = new Store(storeInfos.StoreInfo);
      return store;
    }

    //缓存数据
    cache(){
      if(tools.isNull(this.storeID)){
        alert('PosLogin.Store.cache.storeID===='+this.storeID);
      }
      localStore.set(storeKey,this);
    }

    static cache(obj){
      if(tools.isNull(obj.storeID)){
        console.log('PosLogin.Store.static.cache.storeID===='+this.storeID);
      }
      localStore.set(storeKey,obj);
    }

    //恢复数据
    static restore(){
      let store =  localStore.get(storeKey);
      if(store == null || store == undefined){
        store = emptyStore;
      }
      return store;
    }

    //清空数据
    static clear(){
      localStore.remove(storeKey);
    }
  }
